<script>
    export let icon;
    export let headline;
    export let image;
    export let imageAlt = 'Illustration';
</script>
<div>
    <h2>{icon}</h2>
    <h3>{headline}</h3>
</div>

<style>
    div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0px;
        flex: 1;
    }

    img {
        width: 56px;
        height: 56px;
        object-fit: cover;
        border-radius: 50%;
    }

    h2 {
        font-size: 40px;
        margin: 0;
        padding: 0;
    }

    h3 {
        text-align: center;
        color: var(--on-surface);
        font-family: var(--font-body);
    }

    p {
        text-align: center;
        color: var(--on-surface-50);
    }
</style>